import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import axios from 'axios';
import API_URL from '../../config';

function Register() {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);

        if (formData.password !== formData.confirmPassword) {
            setError('As senhas não coincidem.');
            setLoading(false);
            return;
        }
        if (formData.password.length < 6) {
            setError('A senha deve ter pelo menos 6 caracteres.');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/register`, {
                username: formData.username,
                email: formData.email,
                password: formData.password
            });
            if (response.status === 201) {
                setSuccess('Conta criada com sucesso! Redirecionando...');
                setTimeout(() => navigate('/login'), 2000);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao registrar. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bc-auth">
            <div className="bc-auth-left">
                <div className="bc-auth-left-content">
                    <img src={"benfecalc.svg"} alt="BenfeCalc" height="56" />
                    <div className="bc-auth-tagline">
                        Comece a avaliar imóveis com precisão
                    </div>
                    <div className="bc-auth-sub">
                        Crie sua conta gratuitamente e acesse todas as funcionalidades do sistema.
                    </div>
                    <div className="bc-auth-feats">
                        <div className="bc-auth-feat"><span className="fi">🏠</span> Casas, Galpões, Coberturas e mais</div>
                        <div className="bc-auth-feat"><span className="fi">📐</span> Ross-Heidecke com estados A–I</div>
                        <div className="bc-auth-feat"><span className="fi">🗺️</span> Lotes com delimitação no mapa</div>
                        <div className="bc-auth-feat"><span className="fi">⚙️</span> R8N configurável por usuário</div>
                    </div>
                </div>
            </div>

            <div className="bc-auth-right">
                <div className="bc-auth-box">
                    <div className="bc-auth-title">Criar conta</div>
                    <div className="bc-auth-subtitle">Preencha os dados abaixo para se registrar</div>

                    {error   && <Alert className="bc-alert" variant="danger"  dismissible onClose={() => setError('')}>{error}</Alert>}
                    {success && <Alert className="bc-alert" variant="success" dismissible onClose={() => setSuccess('')}>{success}</Alert>}

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="bc-label">Nome de Usuário</label>
                            <input type="text" className="form-control bc-input"
                                placeholder="Escolha um nome de usuário"
                                name="username" value={formData.username}
                                onChange={handleChange} required autoFocus />
                        </div>
                        <div className="mb-3">
                            <label className="bc-label">E-mail</label>
                            <input type="email" className="form-control bc-input"
                                placeholder="seu@email.com"
                                name="email" value={formData.email}
                                onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="bc-label">Senha</label>
                            <input type="password" className="form-control bc-input"
                                placeholder="Mínimo 6 caracteres"
                                name="password" value={formData.password}
                                onChange={handleChange} required />
                        </div>
                        <div className="mb-4">
                            <label className="bc-label">Confirmar Senha</label>
                            <input type="password" className="form-control bc-input"
                                placeholder="Repita sua senha"
                                name="confirmPassword" value={formData.confirmPassword}
                                onChange={handleChange} required />
                        </div>
                        <button type="submit" className="btn bc-btn bc-btn-primary w-100 mb-3" disabled={loading}>
                            {loading ? 'Criando conta...' : 'Criar Conta'}
                        </button>
                    </form>

                    <div className="text-center" style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>
                        Já tem uma conta?{' '}
                        <Link to="/login" className="bc-auth-link">Fazer login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Register;
